module.exports = __webpack_public_path__ + "static/media/02.acb35842.webp";